// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_59-6";
export var headerCell = "_59-2";
export var rowWrapper = "_59-4";
export var stickyAggregationCell = "_59-a";
export var stickyAggregationRow = "_59-7";
export var stickyColumnCell = "_59-9";
export var stickyColumnHeaderCell = "_59-8";
export var table = "_59-1";
export var virtualRowWrapper = "_59-5";
export var virtualTableContainer = "_59-0";
export var white = "_59-3";